export default __webpack_public_path__ + "static/media/transaction-analysis.822aae96.svg";